import React from "react";

const AuctionPageDashboard = () => {
  return <div>AuctionPageDashboard</div>;
};

export default AuctionPageDashboard;
